import { CompanyIntelligenceResponse } from '../services/jobApplicationService'

export type CompanyIntelligenceCategoryKey = keyof NonNullable<CompanyIntelligenceResponse['categories']>

export const COMPANY_INTEL_CATEGORY_LABELS: Record<CompanyIntelligenceCategoryKey, string> = {
  layoffs: '📉 Layoffs / Restructuring (18mo)',
  hirings: '📈 Hirings / Expansion (6mo)',
  scandals: '⚖️ Scandals / Legal Issues',
  management: '👔 Management Changes',
  reviews_employ: '💼 Employee Reviews',
  reviews_customer: '⭐ Customer Reviews',
  company_size_growth: '📊 Company Size & Growth',
  diversity_esg: '🌿 Diversity & ESG',
  culture_benefits: '🎁 Culture & Benefits',
  competitors_market: '🏁 Competitors & Market',
}
